import { GeneralModel } from "./general.model";
import { Province } from "./province.model";

export class District extends GeneralModel {
    provinceId: number;
    province:Province;
    vseOracleCode: string;
    kmNumber:number;
    isRemote:boolean;
    remoteType: number;
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/app/models/district.model.ts